<template>
  <div class="baseContent-warp">
    <Card class="menu-card">
      <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">复诊随访问卷管理</el-menu-item>
        <el-menu-item index="2">复诊随访题库管理</el-menu-item>
        <el-menu-item index="3">日常随访信息管理</el-menu-item>
      </el-menu>
      <div slot="content">
        <Questionnaire v-if="menuIndex == 1" />
        <QuestionBank v-if="menuIndex == 2" />
        <TipsBank v-if="menuIndex == 3" />
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import Questionnaire from "./Questionnaire.vue"; // 随访问卷管理
import QuestionBank from "./QuestionBank.vue"; // 问卷题库管理
import TipsBank from "./TipsBank.vue"; // 日常随访管理
export default {
  name: "Scheduling",
  components: { Questionnaire, QuestionBank, TipsBank },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('chargeIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods: {
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('chargeIndex', key);
    }
  }
};
</script>